import { render, staticRenderFns } from "./NewGeneXpert.vue?vue&type=template&id=2d1b207e&scoped=true"
import script from "./NewGeneXpert.vue?vue&type=script&lang=js"
export * from "./NewGeneXpert.vue?vue&type=script&lang=js"
import style0 from "./NewGeneXpert.vue?vue&type=style&index=0&id=2d1b207e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b207e",
  null
  
)

export default component.exports